import { API } from './api';
import { Links } from './links';
import { TYPES } from '@/generated/graphql';
import { Module } from './modules';
import {
	Action,
	KeyboardKey,
	FinanceDocumentEntities,
	HelpStationQueryParams,
	SyncActions,
	GetStartedActionCards,
} from './constants';
import { Permission, PermissionAction } from './permissions';
import { Feature } from './features';
import { Assets } from './assets';
import { SENTRY, Setting, WEEK_STARTS_ON } from './settings';
import { Monolith } from './monolith';
import { Validations } from './validations';
import { FeatureFlag } from '@/constants/featureFlags';
import { Rounding } from './rounding';
import { Unit } from './unit';
import { Timing } from './timing';
import * as Colors from './colors';

export const Constants = {
	Module,
	Action,
	KeyboardKey,
	FinanceDocumentEntities,
	Permission,
	PermissionAction,
	Feature,
	FeatureFlag,
	Type: TYPES,
	Assets,
	Setting,
	WEEK_STARTS_ON,
	SENTRY,
	Monolith,
	Links,
	API,
	HelpStationQueryParams,
	Validations,
	SyncActions,
	GetStartedActionCards,
	Rounding,
	Unit,
	Timing,
	Colors,
};
